import React from 'react';
import { connect } from 'react-redux';
import GeneralAggregationChart from '../SystemDashboard/GeneralAggregationChart';
import { colors, yaxis_percentage } from '../../../../constants';
import { getXaxisCategories, getPercentage, isDefined } from '../../../../utils';
import GeneralChart from "./GeneralChart.jsx";

class GeneralQuestionCodeChartContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            asatVisibility: true,
            resVisibility: true,
            csatVisibility: true,
            npsVisibility: true,
            sessionVisibility: true,
        };
        this.toggleDataSeries = this.toggleDataSeries.bind(this);
    }

    //Should change to array based
    toggleDataSeries(e) {
        if (e.dataSeries.name === "ASAT") {
            this.setState({ asatVisibility: !this.state.asatVisibility });
        }
        else if (e.dataSeries.name === "CES") {
            this.setState({ csatVisibility: !this.state.csatVisibility });
        }
        else if (e.dataSeries.name === "Sessions") {
            this.setState({ sessionVisibility: !this.state.sessionVisibility });
        }
    }

    render() {
        const { propId, jibeProgressOverTimeStats, calibratedOnSurveyQuestions, jibeSessionsOverTimeStats,
            maxX, suffixY, valueType, dataTypeForResponses } = this.props;

        if (!jibeProgressOverTimeStats || !Array.isArray(jibeProgressOverTimeStats)) {
            return <div className="flex justify-content-center" style={{ height: '398px', backgroundColor: 'rgb(252,252,255)' }}>
                <img src="../../../../../Assets/Images/V3Design/Zac.gif" width="350" />
            </div>;
        }
        else if (jibeProgressOverTimeStats.length == 0) {
            return <div className="flex justify-content-center" style={{ height: '398px', backgroundColor: 'rgb(252,252,255)' }}>
                No data
            </div>;
        }

        let asatData = jibeProgressOverTimeStats.filter(r => r.questionCode === 'ASAT');
        let resData = jibeProgressOverTimeStats.filter(r => r.questionCode === 'RES');
        let csatData = jibeProgressOverTimeStats.filter(r => r.questionCode === 'CSAT');
        let npsData = jibeProgressOverTimeStats.filter(r => r.questionCode === 'NPS');
        if (valueType === "yesResponsePercentage") {
            asatData = asatData.filter(p => (p.finalResponse === 'Yes' || p.finalResponse === 'Satisfied'));
            resData = resData.filter(p => (p.finalResponse === 'Yes' || p.finalResponse === 'Satisfied'));
            csatData = csatData.filter(p => (p.finalResponse === 'Yes' || p.finalResponse === 'Satisfied'));
        }

        const emptyDataPoint = [{
            label: 0,
            y: undefined
        }];

        const asatDataPoints = asatData.map(t => {
            let yValue = undefined;

            if (valueType === "yesResponsePercentage") {
                yValue = dataTypeForResponses === "Customer"
                    ? getPercentage(t.customerResponseCnt, t.sumCustomerResponses)
                    : getPercentage(t.effectiveResponseCntRounded, t.sumQuestionEffectiveResponses);
            }
            else if (valueType === "overalSuccessRatePercent") {
                yValue = t.overalSuccessRatePercent;
            }

            return {
                label: t.windowStart.slice(0, 5),
                y: yValue
            }
        });

        const asatPerformanceData = {
            type: "spline",
            color: colors.fourth200,
            name: "ASAT",
            showInLegend: true,
            dataPoints: this.state.asatVisibility ? asatDataPoints : emptyDataPoint
        };

        const resDataPoints = resData.map(t => {
            let yValue = undefined;

            if (valueType === "yesResponsePercentage") {
                yValue = dataTypeForResponses === "Customer"
                    ? getPercentage(t.customerResponseCnt, t.sumCustomerResponses)
                    : getPercentage(t.effectiveResponseCntRounded, t.sumQuestionEffectiveResponses);
            }
            else if (valueType === "overalSuccessRatePercent") {
                yValue = t.overalSuccessRatePercent;
            }

            return {
                label: t.windowStart.slice(0, 5),
                y: yValue
            }
        });

        const resPerformanceData = {
            type: "spline",
            color: colors.secandary200,
            name: "Res",
            showInLegend: true,
            dataPoints: this.state.resVisibility ? resDataPoints : emptyDataPoint
        };

        const csatDataPoints = csatData.map(t => {
            let yValue = undefined;

            if (valueType === "yesResponsePercentage") {
                yValue = dataTypeForResponses === "Customer"
                    ? getPercentage(t.customerResponseCnt, t.sumCustomerResponses)
                    : getPercentage(t.effectiveResponseCntRounded, t.sumQuestionEffectiveResponses);
            }
            else if (valueType === "overalSuccessRatePercent") {
                yValue = t.overalSuccessRatePercent;
            }

            return {
                label: t.windowStart.slice(0, 5),
                y: yValue
            }
        });

        const csatPerformanceData = {
            type: "spline",
            color: colors.fourth200,
            name: "CES",
            showInLegend: true,
            dataPoints: this.state.csatVisibility ? csatDataPoints : emptyDataPoint
        };

        const npsDataPoints = npsData.map(t => {
            let yValue = undefined;

            if (valueType === "yesResponsePercentage") {
                yValue = dataTypeForResponses === "Customer"
                    ? getPercentage(t.customerResponseCnt, t.sumCustomerResponses)
                    : getPercentage(t.effectiveResponseCntRounded, t.sumQuestionEffectiveResponses);
            }
            else if (valueType === "overalSuccessRatePercent") {
                yValue = t.overalSuccessRatePercent;
            }

            return {
                label: t.windowStart.slice(0, 5),
                y: yValue
            }
        });

        const npsPerformanceData = {
            type: "spline",
            color: colors.primary200,
            name: "NPS",
            showInLegend: true,
            dataPoints: this.state.npsVisibility ? npsDataPoints : emptyDataPoint
        };

        const data = [];
        if (calibratedOnSurveyQuestions.some(item => item.questionCode === 'ASAT')) {
            data.push(asatPerformanceData);
        }
        if (calibratedOnSurveyQuestions.some(item => item.questionCode === 'RES')) {
            data.push(resPerformanceData);
        }
        if (calibratedOnSurveyQuestions.some(item => item.questionCode === 'CSAT')) {
            data.push(csatPerformanceData);
        }
        if (calibratedOnSurveyQuestions.some(item => item.questionCode === 'NPS')) {
            data.push(npsPerformanceData);
        }

        return (
            <>
                <GeneralChart
                    yAxis={yaxis_percentage}
                    series={data}
                    showLegends={true}
                    xAxisCategories={[...getXaxisCategories(data)]}
                />
            </>
        );
    }
}

const select = state => ({});

export default connect(select)(GeneralQuestionCodeChartContainer);